import React, { useContext, useEffect, useState } from "react";
import "./App.css";
import { AppProviders } from "./providers/AppProviders";
import SlugQueryManager from "./appcomponents/SlugQueryManager";
import AdminApp from "./appcomponents/AdminApp";
import ModeratorApp from "./appcomponents/ModeratorApp";
import OperatorApp from "./appcomponents/OperatorApp";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Success from "./pages/Success";
import Cancel from "./pages/Cancel";

import SimpleBottomNavigation from "./SimpleBottomNavigation";
import { CognitoUserContext } from "./contexts/cognitoUserContext";
import { getUserRole } from "./services/user/cognitoService";
import { on } from "./services/auth/authService";
import ErrorBoundary from "./components/ErrorBoundary";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";

function AppContent() {
  const { cognitoUser, setCognitoUser } = useContext(CognitoUserContext);
  const role = getUserRole(cognitoUser);
  const [loggedOutDialogOpen, setLoggedOutDialogOpen] = useState(false);

  useEffect(() => {
    return on('signOut', () => {
      console.log('[Auth] Sign out event received - clearing user and showing dialog');
      setCognitoUser(null);
      setLoggedOutDialogOpen(true);
    });
  }, [setCognitoUser]);

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/success" element={<Success />} />
        <Route path="/cancel" element={<Cancel />} />
        <Route path="/subscription/success" element={<Success />} />
        <Route path="/subscription/cancel" element={<Cancel />} />

        {/* Witness Statement Routes - handled via dialogs in OperatorApp, not direct routes */}

        <Route path="/" element={
          <>
            {role === 'ADMIN' && (
              <ErrorBoundary fallbackMessage="The admin interface encountered an error.">
                <div className="App">
                  <AdminApp />
                </div>
              </ErrorBoundary>
            )}
            {role === 'MODERATOR' && (
              <ErrorBoundary fallbackMessage="The moderator interface encountered an error.">
                <div className="App">
                  <ModeratorApp />
                </div>
              </ErrorBoundary>
            )}
            {role === 'OPERATOR' && (
              <ErrorBoundary fallbackMessage="The operator interface encountered an error.">
                <div className="App">
                  <OperatorApp />
                </div>
              </ErrorBoundary>
            )}
            {(role === 'STANDARD' || role === 'GUEST') && (
              <ErrorBoundary fallbackMessage="The search interface encountered an error.">
                <>
                  <div className="App">
                    <SlugQueryManager />
                  </div>
                  <SimpleBottomNavigation />
                </>
              </ErrorBoundary>
            )}
          </>
        } />
      </Routes>

      {/* Logged Out Dialog */}
      <Dialog
        open={loggedOutDialogOpen}
        onClose={() => setLoggedOutDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Session Expired</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your session has expired. Please sign in again to continue.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setLoggedOutDialogOpen(false);
              window.location.reload();
            }}
            color="primary"
            variant="contained"
            autoFocus
          >
            Sign In
          </Button>
        </DialogActions>
      </Dialog>
    </BrowserRouter>
  );
}

export default function WrapperApp() {
  return (
    <AppProviders>
      <AppContent />
    </AppProviders>
  );
}
